import React, { useCallback, useEffect, useMemo, useState } from "react";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { useFormContext } from "../../../context/FormContext";
// import { FormLayoutWithEdit } from "../FormSection";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import Loader from "../../../Layouts/Loader/Loader";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { createChecksum } from "../../../commonFunctions/fileFolderConfig";
import {
  getGridLayoutForDesktop,
  getGridsOfFormFields,
  getMAppedAndModifiedFormField
} from "../../../commonFunctions/formFunc";
import { useAppOrgContext } from "../../../context/AppOrgContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { FormLayoutWithEdit } from "../../RdbmsForm/RdbmsFormSection";
import FormGeneralSetting from "../FormGeneralSetting";
import RightSideFieldsBar from "../RightSideFieldsBar";
import RdbmsFormQuery from "./RdbmsFormQuery";
import RdbmsJobs from "./RdbmsJobs";
import RdbmsSettings from "./RdbmsSettings";

const RDBMSFormSection = () => {
  const {
    selectedForm,
    handleSaveForm,
    renderFieldsData,
    renderFieldsArray,
    rdbmsFormSettingData,
    formSectionsData,
    setSelectedSectionData,
    setRenderFieldsArray,
    setRdbmsConfig
  } = useFormContext();

  const { currentChecksum } = useAppOrgContext();
  const [isRdbmsFormOpen, setIsRdbmsFormOpen] = useState(false);
  const [dragFromOutside, setDragFromOutside] = useState(false);
  const tableID = selectedForm.parentData.split("/")[0];
  const [isLoader, setIsLoader] = useState(true);
  const [allDbConnectors, setAllDbConnectors] = useState([]);

  const makeFormSectionData = (fields, desktopLayout, mobileLayout) => {
    return [
      {
        name: "Section 1",
        fields: fields,
        progress_bar_title: "S1",
        desktop_layout: desktopLayout,
        mobile_layout: mobileLayout,
        key: "Section_123"
      }
    ];
  };

  const fetchRdbmsForm = async () => {
    try {
      setIsLoader(true);
      const { data } = await axiosInstance.get(`/rdbmsform/${selectedForm.id}`);
      // setRdbmsQuery(data.config.rdbms_query);
      setRdbmsConfig((prev) => ({
        ...prev,
        rdbms_query: data.config.rdbms_query,
        owner_assignment: data.config.owner_assignment || {},
        rdbms_pre_submission: data.config.rdbms_pre_submission || [],
        rdbms_jobs_trigger: data.config.rdbms_jobs_trigger || [],
        rdbms_jobs_trigger_formula: data.config.rdbms_jobs_trigger_formula || []
      }));
      renderFieldsData.current = {};
      //   rdbmsFormSettingData.current = {
      //     settings: data.config.settings
      //   };
      rdbmsFormSettingData.current = {
        name: data.config.settings?.name || "",
        submit: data.config.settings?.submit || "",
        reset: data.config.settings?.reset || "",
        style: {
          min_width: data.config.settings?.style?.min_width || "",
          width: data.config.settings?.style?.width || "",
          max_width: data.config.settings?.style?.max_width || ""
        }
      };

      const obj = getMAppedAndModifiedFormField("subform", data.config.fields || []); // check
      renderFieldsData.current = obj;
      const gridArray = getGridsOfFormFields(data.config.fields || []);

      const formLikeData = makeFormSectionData(
        data.config.fields || [],
        data.config?.desktop_layout || {},
        data.config?.mobile_layout || {},
        data.config?.tablet_layout || {}
      );
      formSectionsData.current = formLikeData;

      formLikeData.forEach((sec, i) => {
        // if (!sec.desktop_layout) {
        const newRenderArrayForDesktop = getGridLayoutForDesktop(
          formSectionsData.current[i].fields,
          sec.desktop_layout || {}
        );
        formSectionsData.current[i].desktop_layout = newRenderArrayForDesktop;
        const newRenderArrayForMobile = getGridLayoutForDesktop(
          formSectionsData.current[i].fields,
          sec.mobile_layout || {}
        );
        formSectionsData.current[i].mobile_layout = newRenderArrayForMobile;
        const newTabletLayout = getGridLayoutForDesktop(formSectionsData.current[i].fields, sec.tablet_layout || {});
        formSectionsData.current[i].tablet_layout = newTabletLayout;
        // }
        const obj = getMAppedAndModifiedFormField("subform", sec.fields || []); //check
        renderFieldsData.current = { ...renderFieldsData.current, ...obj };
        // setAllFieldDataInLayoutData(sec.fields);
      });

      setSelectedSectionData(0);
      setRenderFieldsArray(gridArray);
      const initialDataObj = {
        fields: data.config.fields,
        desktop_layout: data.config.desktop_layout,
        mobile_layout: data.config.mobile_layout,
        tablet_layout: data.config.tablet_layout,
        settings: data.config.settings
      };
      const newChecksum = createChecksum(initialDataObj);
      currentChecksum.current = newChecksum;

      setIsLoader(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  // Modify the useEffect where you're setting userGroupAssignments
  const fetchDBConnectors = async () => {
    try {
      const { data } = await axiosInstance.get(`highleveluser/dbconnector`);
      setAllDbConnectors(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (selectedForm.id) {
      fetchRdbmsForm();
    }
    fetchDBConnectors();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedForm.id]);

  const handleDragStart = useCallback(
    (e, name) => {
      e.dataTransfer.setData("type", name);
      setDragFromOutside(true);
    },
    [setDragFromOutside]
  );

  const memoizedRightSideFieldsBar = useMemo(() => {
    return <RightSideFieldsBar from={"subform"} handleDragStart={handleDragStart} />;
  }, [handleDragStart]);

  if (isLoader) return <Loader />;
  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`rdbmsform/${selectedForm.name}`}
        savePage={handleSaveForm}
        settingPage={() => setIsRdbmsFormOpen(true)}
        currentConfig={[renderFieldsData.current, renderFieldsArray, rdbmsFormSettingData.current]}
        pageName="rdbmsform"
      />

      <BuilderTabs
        tabsClass={"activity_tab"}
        tabs={[
          {
            label: "Form",
            content: (
              <div className="sub-form-section">
                <div className="sub_form_main_section">
                  <div className="form_outer_section">
                    <FormLayoutWithEdit
                      dragFromOutside={dragFromOutside}
                      setDragFromOutside={setDragFromOutside}
                      from="form"
                      tableID={tableID}
                      onChangeActiveMode={() => {}}
                    />
                  </div>
                </div>
                <div className="rightsidebar">{memoizedRightSideFieldsBar}</div>
              </div>
            )
          },
          {
            label: "Queries",
            content: (
              <div className="form_outer_section">
                <RdbmsFormQuery allDbConnectors={allDbConnectors} />
              </div>
            )
          },
          {
            label: "Jobs",
            content: <RdbmsJobs />
          },
          {
            label: "Settings",
            content: <RdbmsSettings />
          }
        ]}
      />
      <BuilderModal
        isOpen={isRdbmsFormOpen}
        onClose={() => setIsRdbmsFormOpen(false)}
        modalName="Edit RDBMS Form Setting"
      >
        <FormGeneralSetting formSettingData={rdbmsFormSettingData} setIsModalOpen={() => setIsRdbmsFormOpen(false)} />
      </BuilderModal>
    </div>
  );
};

export default RDBMSFormSection;
